module.exports = __webpack_public_path__ + "img/help.64e718eb.svg";